import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { ShoppingBag, ArrowRight } from "lucide-react";

const UniverseStore = ({ universeId, universeName }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!universeId) return;
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/products?universe_id=${universeId}`);
        setProducts(res.data.slice(0, 4));
      } catch {
        // Silent
      }
    };
    fetch();
  }, [universeId]);

  if (products.length === 0) return null;

  return (
    <div className="card-surface p-6" data-testid="universe-store-section">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded bg-amber-500/15 flex items-center justify-center">
            <ShoppingBag className="w-4 h-4 text-amber-500" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-white font-['Outfit']">Shop {universeName}</h3>
            <p className="text-[11px] text-slate-500">{products.length} items available</p>
          </div>
        </div>
        <Link
          to={`/store?universe=${universeId}`}
          className="flex items-center gap-1 text-xs text-amber-500 hover:text-amber-400 transition-colors"
          data-testid="view-all-merch"
        >
          View All <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/store/product/${p.id}`}
            className="group rounded-lg overflow-hidden border border-white/5 hover:border-amber-500/20 transition-all"
            data-testid={`universe-product-${p.id}`}
          >
            <div className="aspect-square overflow-hidden bg-[#030712]">
              <img
                src={p.image || "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=300"}
                alt={p.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <div className="p-2.5">
              <p className="text-white text-xs font-medium truncate">{p.name}</p>
              <p className="text-amber-500 text-xs font-semibold mt-0.5">R{p.price?.toFixed(2)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default UniverseStore;
